import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
  component: HomeComponent,
});

const modes = [
  {
    to: "/dictation",
    title: "書き起こし",
    description: "話したことばを、ひらがなで文節ごとに書き起こします。",
    emoji: "✍️",
  },
  {
    to: "/objects",
    title: "ものの名前",
    description: "ことばを言うと、その絵を表示します。",
    emoji: "🍎",
  },
  {
    to: "/grammar",
    title: "文法",
    description: "正しい文と間違った文を絵で見比べます。",
    emoji: "🥖",
  },
  {
    to: "/review",
    title: "復習",
    description: "今までに教えたことばを思い出します。",
    emoji: "📚",
  },
  {
    to: "/sign-review",
    title: "手話復習",
    description: "書き起こした文を、手話でどう表現するか見返します。",
    emoji: "🤟",
  },
  {
    to: "/sign-words",
    title: "手話単語検索",
    description: "単語を打つと、その手話をすぐ見られます。",
    emoji: "🔎",
  },
  {
    to: "/fingerspelling",
    title: "指文字表",
    description: "指文字を、かなごとに見て思い出します。",
    emoji: "🖐️",
  },
  {
    to: "/fingerspelling/drill",
    title: "指文字ドリル",
    description: "かなから指文字をつくる、指文字からかなをよむ練習をします。",
    emoji: "🎯",
  },
] as const;

function HomeComponent() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">何をする？</h1>
        <p className="text-sm text-neutral-600 mt-1">
          語彙を視覚で補完するモードを選んでください
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {modes.map((m) => (
          <Link
            key={m.to}
            to={m.to}
            className="block rounded-2xl border border-neutral-200 bg-white p-5 hover:border-neutral-400 transition-colors"
          >
            <div className="text-4xl mb-3">{m.emoji}</div>
            <div className="font-semibold">{m.title}</div>
            <div className="text-sm text-neutral-600 mt-1">{m.description}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
